import { useQuery } from '@pinia/colada';

import showingAgentssService from '../services/showing-agents.service';

export const showingAgentsQueryKey = 'showing-agents';

export function useShowingAgentsQuery() {
  return useQuery({
    key: () => [showingAgentsQueryKey],
    query: () => showingAgentssService.getList(),
  });
}
